export enum FeatureFlags {
  TPRO_NEXT_VERSION_AVAILABLE = 'tpro-next-version-available',
  TPRO_AI_FEATURES = 'tpro-ai-features',
  TPRO_ANALYTICS_COMPARISONS = 'tpro-analytics-comparisons',
  TPRO_MARKETING = 'tpro-marketing',
  TPRO_FLOORPLANS = 'tpro-floorplans',
  TPRO_VENUE_BILLING = 'tpro-venue-billing',
  TPRO_EMPTY_STATES = 'tpro-empty-states',
  TPRO_TABLE_TIERS = 'tpro-table-tiers',
  TPRO_WIDGETS = 'tpro-widgets',
  TPRO_TAP_TO_PAY = 'taptopay',
}
